import React, {useState} from "react";
import {useTranslation} from "react-i18next";

//components:
import {FilterSearchBar, ReusableTable} from "../../../../widgets";

const UsersTable = ({
    title = "",
    headRows,
    rows = [],
    formatRow,
    emptyMessage = "",
    isLoading = false,
    errorMessage = {},
    withFilter = true,
}) => {
    const {t} = useTranslation();

    const [filteredRows, setFilteredRows] = useState(rows);

    return (
        <div className="userspage_table">
            <h4 className="card-title mb-5">{title}</h4>
            {withFilter ? (
                <FilterSearchBar
                    allItems={rows}
                    field="name"
                    placeholder={t("ADMINPANEL.USERS.SEARCHBAR_PLACEHOLDER")}
                    setFiltered={setFilteredRows}
                />
            ) : null}
            <ReusableTable
                headRows={headRows}
                allRows={rows}
                filteredRows={filteredRows}
                formatRow={formatRow}
                isLoading={isLoading}
                errorMessage={errorMessage}
                emptyMessage={emptyMessage}
                pagination
            />
        </div>
    );
};

export default UsersTable;
